import { tickAria, tickCount, type CompletedWeek, type TickState } from "../domain/weekDone";
import "./WeekTicks.css";

/**
 * The completed week (kit §55, ADR-066): a row per kind — its label, "2 of 3", and a mark a day
 * Monday to Sunday: a tick for done, a ring to come, a filled ring today, a dash for nothing.
 * Nothing red, nothing "behind"; it draws what `domain/weekDone.ts::completedWeek` says.
 */

const LETTERS = ["M", "T", "W", "T", "F", "S", "S"];

function Mark({ s }: { s: TickState }) {
  return (
    <span className={`k-weekticks__mark k-weekticks__mark--${s}`} aria-hidden="true">
      {s === "done" ? (
        <svg viewBox="0 0 12 12" width="12" height="12">
          <path d="M2.5 6.4 5 8.8 9.6 3.4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : null}
    </span>
  );
}

export function WeekTicks({ week, ariaLabel }: { week: CompletedWeek; ariaLabel?: string }) {
  return (
    <section className="k-weekticks" aria-label={ariaLabel ?? `This week, ${week.span}`}>
      {week.rows.map((t) => (
        <div key={t.kind} className="k-weekticks__row" role="img" aria-label={tickAria(t)}>
          <span className="k-weekticks__label">{t.label}</span>
          <span className="k-weekticks__count">{tickCount(t)}</span>
          {t.days.map((s, i) => (
            <Mark key={i} s={s} />
          ))}
        </div>
      ))}
      <div className="k-weekticks__row k-weekticks__row--axis" aria-hidden="true">
        <span className="k-weekticks__label" />
        <span className="k-weekticks__count" />
        {LETTERS.map((l, i) => (
          <span key={i} className="k-weekticks__day">
            {l}
          </span>
        ))}
      </div>
    </section>
  );
}
